import { call, put, takeLatest } from 'redux-saga/effects';
import {
  changeStatusTask,
  createTask,
  createTaskComment,
  deleteTask,
  getTaskDetail,
  getTaskList,
  updateTask,
} from '../../api/constlink';
import {
  createTaskAsync,
  CREATE_TASK,
  deleteTaskAsync,
  DELETE_TASK,
  getTaskListAsync,
  GET_TASK_LIST,
  updateTaskAsync,
  UPDATE_TASK,
  getTaskDetailAsync,
  GET_TASK_DETAIL,
  createTaskCommentAsync,
  CREATE_TASK_COMMENT,
  changeStatusTaskAsync,
  CHANGE_STATUS_TASK,
} from './actions';
import { Task, TaskComment } from './types';

function* getTaskListSaga(action: ReturnType<typeof getTaskListAsync.request>) {
  try {
    const tasks: Task[] = yield call(getTaskList, action.payload);
    yield put(getTaskListAsync.success(tasks));
  } catch (e: any) {
    yield put(getTaskListAsync.failure(e));
  }
}

function* createTaskSaga(action: ReturnType<typeof createTaskAsync.request>) {
  try {
    const task: Task = yield call(createTask, action.payload);
    yield put(createTaskAsync.success(task));
  } catch (e: any) {
    yield put(createTaskAsync.failure(e));
  }
}

function* getTaskDetailSaga(
  action: ReturnType<typeof getTaskDetailAsync.request>,
) {
  try {
    const task: Task = yield call(getTaskDetail, action.payload);
    yield put(getTaskDetailAsync.success(task));
  } catch (e: any) {
    yield put(getTaskDetailAsync.failure(e));
  }
}

function* updateTaskSaga(action: ReturnType<typeof updateTaskAsync.request>) {
  try {
    const task: Task = yield call(updateTask, action.payload);
    yield put(updateTaskAsync.success(task));
  } catch (e: any) {
    yield put(updateTaskAsync.failure(e));
  }
}

function* deleteTaskSaga(action: ReturnType<typeof deleteTaskAsync.request>) {
  try {
    const taskId: number = yield call(deleteTask, action.payload);
    yield put(deleteTaskAsync.success(taskId));
  } catch (e: any) {
    yield put(deleteTaskAsync.failure(e));
  }
}

function* createTaskCommentSaga(
  action: ReturnType<typeof createTaskCommentAsync.request>,
) {
  try {
    const taskComment: TaskComment = yield call(
      createTaskComment,
      action.payload,
    );
    yield put(createTaskCommentAsync.success(taskComment));
  } catch (e: any) {
    yield put(createTaskCommentAsync.failure(e));
  }
}

function* changeStatusTaskSaga(
  action: ReturnType<typeof changeStatusTaskAsync.request>,
) {
  try {
    const task: Task = yield call(changeStatusTask, action.payload);
    yield put(changeStatusTaskAsync.success(task));
  } catch (e: any) {
    yield put(changeStatusTaskAsync.failure(e));
  }
}

export function* tasksSaga() {
  yield takeLatest(GET_TASK_LIST, getTaskListSaga);
  yield takeLatest(CREATE_TASK, createTaskSaga);
  yield takeLatest(GET_TASK_DETAIL, getTaskDetailSaga);
  yield takeLatest(UPDATE_TASK, updateTaskSaga);
  yield takeLatest(DELETE_TASK, deleteTaskSaga);
  yield takeLatest(CREATE_TASK_COMMENT, createTaskCommentSaga);
  yield takeLatest(CHANGE_STATUS_TASK, changeStatusTaskSaga);
}
